var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-navigator",class:_vm.modifiers},_vm._l((_vm.navigatorItems),function(navigatorItem){return _c(navigatorItem,{key:navigatorItem.id,tag:"component",staticClass:"mobile-navigator__item",on:{"before-toggle":_vm.itemBeforeToggle}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }